import React from 'react'
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: 240,
    backgroundColor: "#f3f6f9",
    height: "37px",
    borderRadius: "4px",
    border: "solid 1px #ccd6e3",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      margin: 0,
    },
  },
  input: {
    marginLeft: 0,
    flex: 1,
    lineHeight: "2em",
    color: "#3f4355",
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
}));
export const QueueDetailedViewSearch = (props) => {
  const { handleSearch } = { ...props };
  const searchClasses = useStyles();
  const searchValue = useSelector(
    (state) => state.callMonitoringCallsSlice.liveCallsSearchInput
  );

  return (
    <>
      <Paper className={searchClasses.root} elevation={0}>
        <IconButton
          className={searchClasses.iconButton}
          aria-label="Search Queue"
        >
          <SearchIcon />
        </IconButton>
        <InputBase
          className={searchClasses.input}
          placeholder="Search Queue"
          inputProps={{ "aria-label": "Search Queue" }}
          defaultValue={searchValue}
          onChange={(e) => {
            handleSearch(e.target.value);
          }}
        />
      </Paper>
    </>
  );
};
